import React from 'react';
import Select from 'react-select';
import { useTranslationContext } from "./project-builder-main.jsx";


export default function ProjectFormFields({ formData, setFormData, readOnly }) {

    const {translations} = useTranslationContext();

    const projectFormatOptions = [
        { value: false, label: translations.QuoteProject },
        { value: true, label: translations.SalesProject }
    ];

    const projectStatusOptions = [
        { value: "InProgress", label: translations.InProgress },
        { value: "Outgoing", label: translations.Outgoing },
        { value: "Incoming", label: translations.Incoming },
        { value: "Completed", label: translations.Completed },
        { value: "Archived", label: translations.Archived },
        { value: "None", label: translations.None },
    ];

    const projectTypeOptions = [
        { value: "Independent Restaurant", label: translations.IndependentRestaurant },
        { value: "Chain Restaurant", label: translations.ChainRestaurant },
        { value: "Grocery", label: translations.Grocery },
        { value: "C-Store", label: translations.CStore },
        { value: "Stadium/Arena", label: translations.StadiumArena },
        { value: "Zoo/Theater/Amusement Park", label: translations.ZooTheaterAmusementPark },
        { value: "Golf Course", label: translations.GolfCourse },
        { value: "Hotel/Casino", label: translations.HotelCasino },
        { value: "Airport", label: translations.Airport },
        { value: "Convention Center", label: translations.ConventionCenter },
        { value: "K-12", label: translations.K12 },
        { value: "College/University", label: translations.CollegeUniversity },
        { value: "Hospital", label: translations.Hospital },
        { value: "Assisted Living", label: translations.AssistedLiving },
        { value: "Government/Military", label: translations.GovernmentMilitary },
        { value: "Religious Organization", label: translations.ReligiousOrganization },
        { value: "Business/Industry", label: translations.BusinessIndustry },
        { value: "Ice Cream/Frozen Yogurt Shop", label: translations.IceCreamFrozenYogurtShop },
        { value: "Distributor", label: translations.Distributor },
        { value: "Other", label: translations.Other },
    ];

    const handleChange = (e) => {
        setFormData(prevState => ({
            ...prevState,
            [e.target.name]: e.target.value
        }));
    }

    const handleSelectChange = (value, action) => {
        setFormData(prevState => ({
            ...prevState,
            [action.name]: value
        }));
    }

    return (
        <>
            <div className="row">
                <div className="form-group col-md-6">
                    <label htmlFor="projectName">{translations.ProjectName} *</label>
                    <input className="form-control" type="text" id="projectName" name="projectName" required value={formData.projectName} disabled={readOnly} onChange={handleChange} />
                </div>

                <div className="form-group col-md-6">
                    <label htmlFor="id">{translations.ProjectId}</label>
                    <input className="form-control" type="text" id="projectId" name="id" placeholder="Auto Generated" disabled value={formData.id} />
                </div>
            </div>

            <div className="row">
                <div className="form-group col-md-6">
                    <label htmlFor="accountName">{translations.AccountName}</label>
                    <input className="form-control" type="text" id="accountName" name="accountName" value={formData.accountName} disabled={readOnly} onChange={handleChange} />
                </div>

                {/*<div className="form-group col-md-6">
                    <label htmlFor="zipcode">{translations.ZipCode}</label>
                    <input className="form-control" type="text" id="zipCode" name="zipCode" value={formData.zipCode} disabled={readOnly} onChange={handleChange} />
                </div>*/}
            </div>

            {/*<div className="row">
                <div className="form-group col-md-6">
                    <label htmlFor="phoneNumber">{translations.PhoneNumber}<span>({translations.Customer})</span></label>
                    <input className="form-control" type="text" id="phoneNumber" name="phoneNumber" value={formData.phoneNumber} disabled={readOnly} onChange={handleChange} />
                </div>

                <div className="form-group col-md-6">
                    <label htmlFor="emailAddress">{translations.EmailAddress}</label>
                    <input className="form-control" type="email" id="emailAddress" name="emailAddress" value={formData.emailAddress} disabled onChange={handleChange} />
                </div>
            </div>

            <div className="row">
                <div className="form-group col-md-6">
                    <label htmlFor="status">{translations.ProjectStatus}</label>
                    <Select
                        classNamePrefix="styled-select"
                        name="status"
                        id="status"
                        options={projectStatusOptions}
                        value={formData.status}
                        isDisabled={readOnly}
                        isSearchable={false}
                        onChange={handleSelectChange}
                    />
                </div>

                <div className="form-group col-md-6">
                    <label htmlFor="type">{translations.ProjectType}</label>
                    <Select
                        classNamePrefix="styled-select"
                        name="type"
                        id="type"
                        options={projectTypeOptions}
                        value={formData.type}
                        isDisabled={readOnly}
                        isSearchable={false}
                        onChange={handleSelectChange}
                    />
                </div>
            </div>

            <div className="row">
                <div className="form-group col-md-6">
                    <label htmlFor="isMarketingProject">{translations.ProjectFormat}</label>
                    <Select
                        classNamePrefix="styled-select"
                        name="isMarketingProject"
                        id="isMarketingProject"
                        options={projectFormatOptions}
                        value={formData.isMarketingProject}
                        isDisabled={readOnly}
                        isSearchable={false}
                        onChange={handleSelectChange}
                    />
                </div>
            </div>

            <div className="form-group">
                <label htmlFor="notes">{translations.ProjectHeader}</label>
                <textarea className="form-control" id="project-header" name="headerText" rows="6"
                    value={formData.headerText}
                    disabled={readOnly}
                    onChange={handleChange}>
                </textarea>
            </div>

            <div className="form-group">
                <label htmlFor="project-header">{translations.ProjectNotes}</label>
                <textarea className="form-control" id="notes" name="notes" rows="6"
                    value={formData.notes} disabled={readOnly} onChange={handleChange}></textarea>
            </div>*/}
        </>
    );
}